import styled from 'styled-components'

export const Row = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
`
